<section id="link-detail" class="meta-detail d-flex flex-column h-100" *ngIf="link">
  <div class="d-flex align-items-start page-language-choice">
    <div class="form-group row no-gutters align-items-center">
      <label for="language" class="mr-3 mb-0 white-with-border">
        <ng-container i18n>Langue utilisée / <em>Language</em></ng-container>
      </label>
      <div class="col">
        <select id="language" class="form-control" name="language" [(ngModel)]="language" (change)="onLanguageChange()">
          <option *ngFor="let availableLanguage of availableLanguages" [value]="availableLanguage.value">{{ availableLanguage.flag }}&nbsp;{{ availableLanguage.label }}</option>
        </select>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-start options-buttons-row">
    <div class="btn-icon-container" ngbDropdown container="body" placement="bottom-right">
      <button type="button" class="btn btn-primary" ngbDropdownToggle>
        <div>
          Télécharger les metadonnées
          <i class="fa fa-chevron-down"></i>
        </div>
      </button>
      <div aria-labelledby="row-dropdown" class="download-dropdown-menu" ngbDropdownMenu>
        <a class="dropdown-item" (click)="downloadMetadata('json')" i18n>JSON</a>
        <a class="dropdown-item" (click)="downloadMetadata('pdf')" i18n>PDF</a>
        <a class="dropdown-item" (click)="downloadMetadata('xml')" i18n>XML</a>
        <a class="dropdown-item" (click)="downloadMetadata('datacite')" i18n>DATACITE</a>
        <a class="dropdown-item" (click)="downloadMetadata('zip')" i18n>ZIP</a>
      </div>
    </div>
  </div>

  <div class="d-flex align-items-start page-header">
    <h1 class="mr-auto white-with-border">{{displayName()}}</h1>
      <button *ngIf="tooLongTitle && showNameWithEllipsis" (click)="updateNameDisplay($event)" class="show-more-or-less-btn">Voir plus</button>
      <button *ngIf="tooLongTitle && !showNameWithEllipsis" (click)="updateNameDisplay($event)" class="show-more-or-less-btn">Voir moins</button>
  </div>

  <div class="informations-page-content page-content d-flex flex-column">
    <div class="informations-subcontent subcontent">
      <dl class="mb-0 row">
        <div class="col-12 col-xl-8">
          <h2 i18n>Informations</h2>
          <div class="row">
            <div class="col-6">
              <div class="mb-2">
                <dt class="d-inline" i18n>Dépôt / <em>Repository</em> :</dt>&nbsp;
                <dd class="d-inline">
                  <ng-container *ngIf="projectPublicationChecked">
                    <ng-container *ngIf="projectIsPublished"><a [routerLink]="[projectPath, link.projectId]">{{displayProjectName()}}</a></ng-container>
                  </ng-container>
                </dd>
              </div>
              <div class="mb-2">
                <dt class="d-inline" i18n>Type / <em>Type</em> :</dt>&nbsp;
                <dd class="d-inline">{{ressourceType.label}}</dd>
              </div>
              <div class="mb-2">
                <dt class="d-inline" i18n>Url / <em>Uri</em> :</dt>&nbsp;
                <dd class="d-inline">
                  <a [href]="link.url" target="_blank" class="nowrap">
                    {{link.url}}
                    <em class="fa fa-external-link-alt"></em>
                  </a>
                </dd>
              </div>
              <dt class="accordion-title">
                <button type="button" class="btn btn-icon accordion-btn w-100 d-flex"
                  (click)="hideDescription = !hideDescription">
                  <span i18n>Résumé / <em>Abstract</em></span>
                  <em class="fa fa-chevron-up ml-auto" [ngClass]="{rotated: hideDescription}"></em>
                </button>
              </dt>
              <dd class="nl2br accordion-content" [ngClass]="{closed: hideDescription}">{{link.description}}</dd>
            </div>
            <div class="col-6"></div>
          </div>

          <div class="col">
          </div>
          <div class="col">
          </div>
        </div>
      </dl>
    </div>
  </div>

</section>
